"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$ = exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$outboundSchema = exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$inboundSchema = void 0;
exports.getCompanyDetailsByNameCompaniesCompanyNamePostSecurityToJSON = getCompanyDetailsByNameCompaniesCompanyNamePostSecurityToJSON;
exports.getCompanyDetailsByNameCompaniesCompanyNamePostSecurityFromJSON = getCompanyDetailsByNameCompaniesCompanyNamePostSecurityFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$;
(function (GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$) {
    /** @deprecated use `GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$inboundSchema` instead. */
    GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$.inboundSchema = exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$inboundSchema;
    /** @deprecated use `GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$outboundSchema` instead. */
    GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$.outboundSchema = exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$outboundSchema;
})(GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$ || (exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$ = GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$ = {}));
function getCompanyDetailsByNameCompaniesCompanyNamePostSecurityToJSON(getCompanyDetailsByNameCompaniesCompanyNamePostSecurity) {
    return JSON.stringify(exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$outboundSchema
        .parse(getCompanyDetailsByNameCompaniesCompanyNamePostSecurity));
}
function getCompanyDetailsByNameCompaniesCompanyNamePostSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetCompanyDetailsByNameCompaniesCompanyNamePostSecurity' from JSON`);
}
//# sourceMappingURL=getcompanydetailsbynamecompaniescompanynamepost.js.map